export const getters = {
  menuInitialRecommendationList: ({ menuInitialRecommendationList }) => menuInitialRecommendationList,
};
